import PropTypes from 'prop-types';
import React from 'react';
import { Modal,Alert } from 'react-bootstrap';
import diff from 'object-diff';
import GroupDetail from './GroupDetail';
import GroupDetailForm from './GroupDetailForm';

class GroupDetailModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      group_name:null,
      members:null,
      king:0,
      suite:0,
      double:0,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAddSubmit = this.handleAddSubmit.bind(this);
    this.checkGroupName = this.checkGroupName.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.roomtype = this.roomtype.bind(this);
  }

  handleSubmit(values) {
    //debugger
    const changedValues = diff(this.props.group, values);
    //console.log('handle submit: ', changedValues);
    this.props.editGroup(this.props.group.id, changedValues);
    this.props.onClose();
  }
  // handleAddSubmit(values) {
  //   //const changedValues = diff(this.props.group, values);
  //   console.log('handle add submit: ', values);
  //   this.props.editGroup(this.props.group.id, changedValues);
  //   this.props.onClose();
  // }
   changeValue(e){
    let value = e.target.value;
    let name = e.target.name;
    if(name=="name"){
      this.setState({
        group_name:value,
      })
    }
    if(name=="members_count"){
      this.setState({
        members:value,
      })
    }
  }
  roomtype(e){
    let name = e.target.name;
    let value = e.target.value;
    if (name == "suite"){
      if(value==null || value==""){
        this.setState({
          suite:0,
        })
      } else{
        this.setState({
          suite:value,
        })
      }
    }
    else if (name == "king"){
      if(value==null || value==""){
        this.setState({
           king:0,
        })
      } else{
        this.setState({
           king:value,
        })
      }
    }
    else if (name == "double"){
      if(value==null || value==""){
        this.setState({
          double:0,
        })
      } else{
        this.setState({
          double:value,
        })
      }
    }
    else{
      this.setState({
        suite:0,
        king:0,
        double:0,
      })
    }
  }

  handleSubmit(values) {
    //debugger
    const changedValues = diff(this.props.group, values);
    //console.log('handle submit: ', changedValues);
    this.props.editGroup(this.props.group.id, changedValues);
    this.props.onClose();
  }
  // handleAddSubmit(values) {
  //   //const changedValues = diff(this.props.group, values);
  //   console.log('handle add submit: ', values);
  //   this.props.editGroup(this.props.group.id, changedValues);
  //   this.props.onClose();
  // }
  checkGroupName(e){
    let groupsName = [];
    if(this.props.groups.length!=0){
      this.props.groups.map((group)=>{
          groupsName.push(group.name)
      })
      let value = groupsName.includes(e.name)?true:false;
      if(value==true){
        alert("Please enter a different name for this group, you cannot have multiple subgroups with the same name under a Travel Project.")
      } else{
        this.handleAddSubmit(e);
      }
    } else{
      this.handleAddSubmit(e);
    }

  }
  handleAddSubmit(e) {
    let king = parseInt(this.state.king)
    let suite = parseInt(this.state.suite)
    let double = parseInt(this.state.double)
    let members = parseInt(this.state.members)
    let sum = king+suite+double;
    if(members>=sum){
      //debugger
      //e.preventDefault();
     
      //let  payload = {first_name:'Guest', last_name:'Guest',group:0,email:'tusharsm'+i+'@alohatechnology.com'}
      let payloadMember = {
        tour_id: this.props.tour_id,
        group: 0,
        members_count:this.state.members,
        king:this.state.king,
        suite:this.state.suite,
        double:this.state.double,
      };
      let roomTypeVal = {
        tour_id: this.props.tour_id,
        group: 0,
        members:[],
        king:this.state.king,
        suite:this.state.suite,
        double:this.state.double,
      }
      // for(var i=0;i<e.member_count;i++){
      //   payloadMember.push({first_name:'Guestnew', last_name:'Guestnew',group:0,email:'tusharsm'+i+'@alohatechnology.com',tour: this.props.tour_id})
      // }

      //payloadMember = {payloadMember:payloadMember}
      //let payload = {first_name:'Guest', last_name:'Guest',group:response.id,email:'tusharsm'+i+'@alohatechnology.com'}
      const payload = {
        name: this.state.group_name,
        tour: this.props.tour_id,
        members_count:this.state.members,
        memberData:payloadMember,
      };
    
      let id = this.props.newGroup(payload);
      //console.log('group id =' + id)
      this.props.onClose();

    } else{
      alert("Number of room types cannot exceed number of group members.   Please correct in order to continue.")
    }
  }
  render() {
    let detail;
    //console.log('this.props.editing =' + this.props.editing)
    //debugger
    if (this.props.editing) {
      detail = (
        <GroupDetailForm
          group={this.props.group}
          initialValues={this.props.addGroup == true ?' ': this.props.group}
          isEdit={!this.props.addGroup}
          changeValue={this.changeValue}
          roomtype={this.roomtype}
          onSubmit={this.props.addGroup ? this.checkGroupName : this.handleSubmit}
        />
      );
    } else {
      detail = <GroupDetail group={this.props.group} />;
    }
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.addGroup == true ?' ': this.props.group.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{detail}</Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    );
  }
}
// Group: {this.props.group.name != undefined ? this.props.group.name : 'None'}
GroupDetailModal.propTypes = {
  group: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  editing: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  editGroup: PropTypes.func.isRequired,
};

export default GroupDetailModal;


// WEBPACK FOOTER //
// src/routes/tours/components/GroupDetailModal.js